<template>
  <div>
    <page-title title="Criar" :moduleIdentifier="identifier"/>

    <panel>
      <form-group label="Nome" :columns="12">
        <input type="text" v-model="newAttribute.label" class="form-input">
      </form-group>

      <form-group :label="$t('typeSelection.label')" :columns="12">
        <select v-model="newAttribute.typeSelection" class="form-select">
          <option :value=null>{{ $t('choose.label') }}</option>
          <option v-for="typeSelectionOption in typeSelectionOptions" :value="typeSelectionOption">{{ $t(`typeSelection.${typeSelectionOption}.label`) }}</option>
        </select>
      </form-group>

      <form-group label="Opções" v-if="isTypeWithOptions" :columns="12">
        <vue-tags-input
          class="form-input"
          v-model="newAttribute.options"
          :tags="options"
          :separators="[',']"
          :add-on-key="[',']"
          placeholder=""
          :allow-edit-tags="true"
          @tags-changed="newOptions => options = newOptions"/>

        <small class="form-help">Utilize vírgula (,) para múltiplas opções.</small>
      </form-group>

      <form-group label="Categorias" :columns="12">
        <multiselect
          v-model="categoriesSelect"
          :options="marketplaceCategories"
          label="label"
          track-by="code"
          selectLabel=""
          selectedLabel=""
          :multiple="true"
          placeholder="Todas"
        />
      </form-group>
    </panel>

    <panel>
      <button :disabled="savingAttribute" v-bind:class="{ 'is-loading': savingAttribute }" class="btn btn--success" @click="save">
        {{ $t('save.label') }}
      </button>
    </panel>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import { isArray } from 'lodash'
  import { mapFields } from 'vuex-map-fields'
  import api from '@/api'
  import notifier from '@/notifier'
  import PageTitle from '@/components/template/PageTitle'
  import Panel from '@/components/template/Panel'
  import FormGroup from '@/components/template/FormGroup'
  import Multiselect from 'vue-multiselect'
  import VueTagsInput from '@johmun/vue-tags-input'

  export default {
    data: () => ({
      attributes: [],
      categoriesSelect: [],
      loadingCategories: false,
      marketplaceCategories: [],
      newAttribute: {
        categories: [],
        label: null,
        options: '',
        typeSelection: null
      },
      options: [],
      typeSelectionOptions: [
        'select',
        'text',
        'multipleSelect'
      ]
    }),
    props: {
      identifier: {
        type: String,
        required: true
      }
    },
    mounted () {
      this.getCategories()
    },
    methods: {
      ...mapActions('marketplaceAttribute', [
        'saveAttribute'
      ]),
      clearInputs () {
        Object.keys(this.newAttribute)
          .map(key => {
            let newValue = ''
            if (isArray(this.newAttribute[key])) {
              newValue = []
            }

            this.newAttribute[key] = newValue
          })

        this.categoriesSelect = []
        this.options = ''
      },
      getCategories () {
        this.loadingCategories = true
        api.getCategories('marketplace', this.identifier)
          .then(categories => { this.marketplaceCategories = categories })
          .catch(() => {
            notifier.error('Erro ao buscar as categorias do marketplace.', 'Erro')
          })
          .finally(() => { this.loadingCategories = false })
      },
      save () {
        const options = []
        for (let i in this.options) {
          options.push(this.options[i].text)
        }

        this.newAttribute.options = options

        this.saveAttribute({ attribute: this.newAttribute, identifier: this.identifier })
          .then(() => this.clearInputs())
          .catch(() => {})
      }
    },
    computed: {
      ...mapFields({
        savingAttribute: 'marketplaceAttribute.saving'
      }),
      isTypeWithOptions () {
        const selectTypes = ['select', 'multipleSelect']

        return selectTypes.indexOf(this.newAttribute.typeSelection) !== -1
      }
    },
    watch: {
      categoriesSelect (categories) {
        this.newAttribute.categories = categories.map(category => category.code)
      }
    },
    components: {
      PageTitle,
      Panel,
      FormGroup,
      Multiselect,
      VueTagsInput
    }
  }
</script>

<style lang="sass" scoped>
  .vue-tags-input
    max-width: none
</style>



// WEBPACK FOOTER //
// Create.vue?86af13ea